import {StatusInfoInterface} from "@/views/Admin/Events/Event/General/Info/Section/StatusInfo/StatusInfo.interface";

export const StatusInfoSchema: StatusInfoInterface = {
    isCancelModal: false,
    isCopyModal: false,
    isTagModal: false,
    copyDateStart: null,
    tagsConst: null,
}

